<template>
  <section id="work" class="pt-4 md:pt-6 pb-10 md:pb-12 bg-white">
    <div class="container mx-auto px-4 md:px-6">
      <h2 class="text-3xl sm:text-4xl md:text-4xl font-bold text-center mb-2 md:mb-3 text-primary">Our Work</h2>

      <div class="overflow-x-auto mb-6 border-b">
        <div class="flex justify-start md:justify-start min-w-max md:min-w-0 ">
          <button v-for="(tab, index) in tabs" :key="index"
                  @click="activeTab = index"
                  :class="['px-4 md:px-6 py-3 font-semibold transition-colors text-sm md:text-base whitespace-nowrap', activeTab === index ? 'text-primary border-b-2 border-primary' : 'text-gray-500 hover:text-primary']">
            {{ tab.title }}
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">
        <div class="">
          <h3 class="text-2xl md:text-3xl font-bold mb-2 md:mb-3 text-safari-black">{{ tabs[activeTab].title }}</h3>
          <p class="text-gray-700 mb-3 md:mb-4 text-sm md:text-base">{{ tabs[activeTab].description }}</p>
        </div>

        <div class="rounded-lg overflow-hidden h-64 md:h-80 bg-black">
          <iframe
            :key="tabs[activeTab].video"
            :src="tabs[activeTab].video"
            class="w-full h-full"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            loading="lazy"
          >
          </iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          title: 'Safari Chicken Initiative',
          description: 'The profit engine of our ecosystem. High capacity poultry supplies eggs and chicken year round, generates profit, funds expansion and microloans, and supports dignity centered initiatives.',
          video: 'https://www.youtube.com/embed/fBh0gfhFWpg'
        },
        {
          title: 'Safari TechStyle Hub',
          description: 'The jobs engine of our ecosystem. A printing and tailoring hub that prioritizes competitive salaries over profit, guarantees pay and contracts, trains local women, and reinvests gains into growth.',
          video: 'https://www.youtube.com/embed/swp1f6FMun4'
        },
        {
          title: 'Microloan Program',
          description: 'We provide in kind microloans to working entrepreneurs, enabling them to expand their businesses, repay only half of the cost over time, and build a long term partnership with Safari Strives.',
          video: 'https://www.youtube.com/embed/KAbJdcH0j7I'
        }
      ]
    }
  }
})
export default class OurWork extends Vue {}
</script>
